<script setup lang="ts">
import { computed, useTemplateRef } from "vue";
import { isJust, toDomAttr, unwrapMaybeOr, type Maybe } from "../../lib/maybe";
import ZwField from "./ZwField.vue";

defineOptions({ inheritAttrs: false });

export type ZwSelectOption = {
  value: string;
  label: string;
  style?: Record<string, string>;
};

const model = defineModel<string>({ default: "" });

const props = defineProps<{
  /** Callers pass `just(...)` or `nothing` explicitly. */
  label: Maybe<string>;
  id: Maybe<string>;
  options: Maybe<ZwSelectOption[]>;
}>();

const selectOptions = computed(() => unwrapMaybeOr(props.options, []));

const input = useTemplateRef<HTMLSelectElement>("input");

defineExpose({
  focus: () => input.value?.focus(),
  el: input,
});
</script>

<template>
  <ZwField v-if="isJust(label)" :label="label.value" :for-id="id">
    <select
      :id="toDomAttr(id)"
      ref="input"
      v-model="model"
      :aria-label="toDomAttr(label)"
      class="zw-input zw-select"
      v-bind="$attrs"
    >
      <slot>
        <option
          v-for="option in selectOptions"
          :key="option.value"
          :value="option.value"
          :style="option.style"
        >
          {{ option.label }}
        </option>
      </slot>
    </select>
  </ZwField>
  <select
    v-else
    :id="toDomAttr(id)"
    ref="input"
    v-model="model"
    :aria-label="toDomAttr(label)"
    class="zw-input zw-select"
    v-bind="$attrs"
  >
    <slot>
      <option
        v-for="option in selectOptions"
        :key="option.value"
        :value="option.value"
        :style="option.style"
      >
        {{ option.label }}
      </option>
    </slot>
  </select>
</template>
